import { TOfferCategory } from '../../../types/card';

export function isDailyRent(category: TOfferCategory | null): boolean {
  return Boolean(category && category.indexOf('daily') !== -1);
}
